module.exports = "/static/media/pen_icon.e8752ffd.svg";